import { ReactNode } from "react";
import classNames from "classnames";
import { Grid } from "capitalrx-components-2.0/lib/layout";
import styles from "./MainFormSection.module.css";

/** The `MainFormSection` component properties. */
export interface MainFormSectionProps {
  readonly sectionTitle?: string;
  readonly showRequire?: boolean;
  readonly theme?: string;
  readonly removeSectionTitle?: boolean;
  readonly removeSectionTitleWrapper?: boolean;
  readonly bordered?: boolean;

  /** The component children. */
  readonly children?: ReactNode;
}

/**
 * The main form section component.
 * @deprecated Please move away from this and build your own equivalent using updated components.
 */
export const MainFormSection = (props: MainFormSectionProps): ReactNode => {
  const {
    children,
    sectionTitle,
    theme = "",
    showRequire = false,
    removeSectionTitle = false,
    removeSectionTitleWrapper = false,
    bordered = false,
  } = props;

  return (
    <>
      <Grid.Span columns={12}>
        <div className={classNames(styles.sectionTitleWrapper, { [theme]: !!theme && !removeSectionTitleWrapper }, "wrapper-main")}>
          <div className={classNames(styles.sectionTitle, { [styles.remove]: removeSectionTitle })}>{sectionTitle}</div>
          {showRequire && (
            <div className={styles.requiredIndicator}>
              <span>*</span>=Required Field
            </div>
          )}
        </div>
      </Grid.Span>
      <div>
        <div>
          <div className={classNames(styles.mainFormSectionContent, { [styles.border]: bordered, [theme]: !!theme && !removeSectionTitleWrapper }, "main-form-section")}>
            <div>{children}</div>
          </div>
        </div>
      </div>
    </>
  );
};
